import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {useFragment} from 'react-relay'
import useDocumentTitle from '../hooks/useDocumentTitle'

import DialogContent from './DialogContent'
import DialogTitle from './DialogTitle'
import EmailPasswordAuthForm from './EmailPasswordAuthForm'
import ForgotPasswordOneClick from './ForgotPasswordOneClick'
import InvitationCenteredCopy from './InvitationCenteredCopy'
import InvitationDialogCopy from './InvitationDialogCopy'
import InviteDialog from './InviteDialog'






const StyledDialog = styled(InviteDialog)({
  maxWidth: 356
})

const TeamName = styled('span')({
  fontWeight: 600,
  whiteSpace: 'nowrap'
})

const TeamInvitationEmailSignin = (props) => {
  const {invitationToken, verifiedInvitation: verifiedInvitationRef} = props
  const verifiedInvitation = useFragment(
    graphql`
      fragment TeamInvitationEmailSignin_verifiedInvitation on VerifiedInvitationPayload {
        meetingName
        user {
          preferredName
        }
        teamInvitation {
          email
        }
        teamName
      }
    `,
    verifiedInvitationRef
  )
  const {meetingName, user, teamInvitation, teamName} = verifiedInvitation
  useDocumentTitle(`Sign in | Team Invitation`, 'Sign in')
  if (!user || !teamInvitation) return null
  const {preferredName} = user
  const {email} = teamInvitation
  return (
    React.createElement(StyledDialog, null
      , React.createElement(DialogTitle, null, "Welcome back, "  , preferredName, "!")
      , React.createElement(DialogContent, null
        , React.createElement(InvitationDialogCopy, null, "Enter your password"

          , meetingName ? ` to join ${meetingName} for: ` : ' for immediate access to your team: '
          , React.createElement(TeamName, null, teamName)
        )
        , React.createElement(InvitationCenteredCopy, null
          , React.createElement(EmailPasswordAuthForm, {
            email: email,
            isPrimary: true,
            isSignin: true,
            invitationToken: invitationToken,}
          )
          , React.createElement(ForgotPasswordOneClick, { email: email,} )
        )
      )
    )
  )
}

export default TeamInvitationEmailSignin
